module.exports = __webpack_public_path__ + "img/logo-dark.629290ec.png";